import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchAdSenseStatus, insertAdSenseScript, initializeAdSense } from '../../utils/adSenseHelper'

export default function AdBanner() {
  const location = useLocation()
  const adRef = useRef(null)
  const hasInitialized = useRef(false)
  const [adStatus, setAdStatus] = useState({
    enabled: false,
    pageEligible: false,
    adConfig: null
  })

  useEffect(() => {
    let cancelled = false

    const loadStatus = async () => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('[AdSense] Skipping in development mode')
        return
      }

      const host = typeof window !== 'undefined' ? window.location.hostname : ''
      console.log(`[AdSense] Fetching status for path: ${location.pathname}, host: ${host}`)

      const status = await fetchAdSenseStatus(location.pathname, host)
      if (!cancelled) {
        console.log('[AdSense] Status received:', status)
        setAdStatus(status)
      }
    }

    loadStatus()

    return () => {
      cancelled = true
    }
  }, [location.pathname])

  useEffect(() => {
    if (!adStatus.pageEligible || !adStatus.adConfig) {
      console.log('[AdSense] Page not eligible or no config:', { pageEligible: adStatus.pageEligible, hasConfig: !!adStatus.adConfig })
      return
    }

    console.log('[AdSense] Page is eligible, processing AdSense setup')

    if (adStatus.adConfig.adScript) {
      const scriptInjected = insertAdSenseScript(adStatus.adConfig.adScript)
      if (!scriptInjected) {
        console.error('[AdSense] Failed to inject AdSense script')
        return
      }
    } else {
      console.warn('[AdSense] No AdSense script provided in config')
    }

    // Wait a bit for script to load, then initialize
    const initializeTimeout = setTimeout(() => {
      if (typeof window !== 'undefined' && window.adsbygoogle && !hasInitialized.current) {
        const initialized = initializeAdSense()
        if (initialized) {
          console.log('[AdSense] AdSense initialized successfully')
          hasInitialized.current = true
        } else {
          console.warn('[AdSense] AdSense initialization failed')
        }
      } else {
        console.warn('[AdSense] AdSense script not loaded or already initialized')
      }
    }, 1000)

    return () => clearTimeout(initializeTimeout)
  }, [adStatus])

  if (process.env.NODE_ENV !== 'production') {
    return null
  }

  if (!adStatus.pageEligible || !adStatus.adConfig) {
    return null
  }

  const clientId = adStatus.adConfig.adClientId || adStatus.adConfig.publisherId || ''
  const slotId = adStatus.adConfig.adSlots?.[0]?.slotId || ''

  if (!clientId) {
    return null
  }

  return (
    <div ref={adRef} className="w-full my-4">
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', height: 'auto' }}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  )
}
